import React from 'react';
import useUser from '../hooks/useUser';
import ServerLocation from './server/Location';
import ClientLocation from './client/Location';

const Location = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    if (roleLower === 'client') {
        return <ClientLocation />;
    }
    return <ServerLocation />;
};

export default Location;
